module.exports = __webpack_public_path__ + "img/Render-icon.c99831e3.svg";